import { graphql } from '@gql';

export const GET_COUNTRIES_TREE = graphql(`
    query GetCountriesTree {
        countries(first: 500, orderBy: { field: NAME, direction: ASC }) {
            edges {
                node {
                    id
                    name
                    parent {
                        id
                    }
                    countryStandards {
                        description
                    }
                }
            }
        }
    }
`);
